import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import styles from "./VideoCard.module.css";

interface YoutubePlayerInterface {
  url: string;
  playing: boolean;
  setPlaying: React.Dispatch<React.SetStateAction<boolean>>;
  width?: string;
  height?: string;
  style?: React.CSSProperties;
  className?: string;
  controls?: boolean;
  muted?: boolean;
  responsive?: boolean;
}

const YoutubePlayer = ({
  url,
  playing,
  setPlaying,
  width,
  height,
  style,
  className,
  controls,
  muted,
  responsive
}: YoutubePlayerInterface) => {
  const onPause = () => {
    setPlaying(false);
  };

  const onPlay = () => {
    setPlaying(true);
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [maxWidth, setMaxWidth] = useState<string | undefined>()

  useEffect(() => {
    if (!responsive) return;

    if (windowWidth < 800) {
      setMaxWidth("100vw")
    } else {
      setMaxWidth("50vw")
    }

  }, [windowWidth, setMaxWidth, responsive])

  useEffect(() => {
    window.onresize = () => {
      setWindowWidth(window.innerWidth);
    };
  }, []);

  if (
    url === "" ||
    url.startsWith("NOVIDEO") ||
    url.startsWith("DUMMYURL") ||
    url.startsWith("NOMATCH")
  )
    return <div className={styles.placeholderDiv} style={{ width: width }}>
      Video zatím není dostupné.
    </div>

  return (
    <ReactPlayer
      playing={playing}
      onPlay={onPlay}
      onPause={onPause}
      url={url}
      width={responsive && windowWidth < 800 ? "100vw" : width}
      height={responsive && windowWidth < 800 ? "calc(100vw / 16 * 9)" : height}
      style={{ maxWidth, maxHeight: windowWidth < 800 ? "35vh" : "initial", ...styles }}
      className={className}
      muted
      controls={controls}
      config={{
        youtube: {
          playerVars: { showinfo: 0 }
        }
      }}
    />
  );
};

export default YoutubePlayer;
